import { addActiveAssessment } from "../../actions/assessment.action"
import * as FlashMessage from "../../shared/utils/flashMessage"
import CONFIG from "../../config"
import { SUCCESS } from "../../shared/constants/messages.constants"

export const onPauseAssessment = (data = {}) => {
  FlashMessage.success(SUCCESS.PAUSE_ASSESSMENT_SUCCESSFULLY)
  
  CONFIG.Store.dispatch(addActiveAssessment(data))
}